module.exports = __webpack_public_path__ + "static/media/family-pic.9da7be61.jpg";